module.exports = __webpack_public_path__ + "img/IMG_1826.631aaea6.jpg";